import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { MarketViewsUtil } from '@ddt-web/common';
import { ComponentData } from '@ddt-web/data-service';

import { MarketViewConfig } from '../models/market-view-config.interface';

@Component({
	selector: 'mv-market-views',
	templateUrl: './market-views.component.html',
	styleUrls: ['./market-views.component.scss']
})
export class MvMarketViewsComponent implements OnChanges {
	@Input() public data?: ComponentData;
	@Input() public defaultTranslationFromConfig?: MarketViewConfig;
	@Input() public showHeader: boolean = true;
	@Input() public asOfDate?: string;

	public allCells: { header: string[]; body: string[][] }[];
	public assetClasses: string[];
	public dataColumnClass;
	public summaryItems;
	constructor(private contentService: ContentService) { }

	public ngOnChanges(): void {
		if (this.defaultTranslationFromConfig?.rows?.length > 1) {
			[this.assetClasses, this.allCells] = MarketViewsUtil.getDataFromConfig(this.defaultTranslationFromConfig);
		}
		else {
			[this.assetClasses, this.allCells] = MarketViewsUtil.getAllCellsDcr(this.contentService);
		}

		this.summaryItems = this.contentService
			.get('MARKET_VIEWS_SUMMARY', 'MARKET_VIEWS_SUMMARY')
			.replace('<ul>', '')
			.replace('</ul>', '');
	}

	public getClass(index: number): string {
		switch (index) {
			case 0:
				return 'col-2 col-sm-5';
			case 1:
				return 'col-5 col-sm-6';
			case 2:
				return 'col-17 col-sm-13';
			default:
				return 'col-8';
		}
	}

	public getSvgTypeAndClass(dcrKey: string): string {
		if (this.defaultTranslationFromConfig?.rows?.length > 1) {
			return dcrKey;
		} else {
			return this.contentService.get(dcrKey, 'neutral').toLowerCase();
		}
	}
}
